import { createFileRoute } from '@tanstack/react-router'
import { AccountHomeLayout, LoanAppForm } from 'merchant-components'

export const Route = createFileRoute('/application/$id/renewal')({
  component: () => <AccountHomeLayout outlet={<LoanAppForm />} />,
})

